import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class CustomerForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [ '', Validators.required ],
      address: [ '', Validators.required ],
      city: [ '', Validators.required ],
      zipCode: [ '', Validators.required ],
      country: [ '', Validators.required ],
      phone: [ '', Validators.required ],
      moneybirdContactId: [ '' ],
      firstName: [ '' ],
      lastName: [ '' ],
    });
  }
}
